module.exports = __webpack_public_path__ + "static/media/helexia_duration_icon.e18fd553.svg";